"use strict";

(function($){

	var lazyLoadInView = true;

	var $window = $(window);

	var isTouchDevice = Utils.isTouchDevice();
	var isRetinaDevice = Utils.isRetina();

	var supports = {
		calc: Utils.checkAllCalc()
	};

	var easeOutCubicFunc = function (t, b, c, d) {
		var ts = (t /= d) * t;
		var tc = ts * t;
		return b + c * (tc + -3 * ts + 3 * t);
	};

	/***************************
	 *
	 *	ANIMATED SCROLLTO
	 *
	 ***************************/

	function scrollTo(element, offset, duration) {
		var $target = $(element);
		var $header = $('.header');
		if (typeof offset === 'undefined') {
			offset = 40;
			if ( $header.length ) {
				offset += $header.outerHeight();
			}
		}
		if (typeof duration === 'undefined') {
			duration = 800;
		}
		if ($target.length) {
			var targetTop = $target.offset().top - offset;
			if ($('html').hasClass('menu-open')) {
				$('html').removeClass('menu-open');
			}
			$('html,body').animate({ scrollTop: targetTop }, duration);
			console.log('scrollTo', targetTop, $target);
		}
	}

	function gravityFormsCustomRadioCheckboxes($form) {
		$form.find('input[type="checkbox"], input[type="radio"]').not('.no-input-replace').not('#ship-to-different-address-checkbox').each(function(){
			var $input = $(this);
			var $gfield = $input.closest('.gfield');
			if ($gfield.length && !$gfield.hasClass('no-input-replace') && !$gfield.hasClass('image-choices-field')) {
				$input.iCheck({
					checkboxClass: 'icheckbox_minimal',
					radioClass: 'iradio_minimal',
					increaseArea: '20%' // optional
				});
				// ensures change events fire (eg for conditional logic)
				$input.on('ifToggled', function(e){
					$(this).trigger('change');
				});
			}
		});
	}

	function gravityFormsCustomSelects($form) {
		$form.find('.gfield select').not('.stylized').not('[multiple]').not('.chzn-done').not('.hasCustomSelect').not('.no-customSelect').not('.niceSelect').customSelect();
	}

	console.log('adding::gform_post_render');

	$(document).bind('gform_post_render', function(e, formId, currentFormPage) {

		console.log('gform_post_render', formId);

		var $form = $('#gform_' + formId);
		$form.attr('novalidate', 'novalidate');

		$form.addClass('gform_form');

		$form.find('.gform_previous_button, .gform_next_button, input[type="submit"], button').addClass('btn btn--secondary btn--yellow');
		$form.find('.gform_button_select_files').addClass('btn btn--secondary');

		$form.find('.gfield.disabled').each(function(){
			$(this).find('input, textarea, select').addClass('disabled');
		});

		if ($form.hasClass('autocomplete-off')) {
			$form.attr('autocomplete', 'off');
		}

		gravityFormsCustomSelects($form);
		gravityFormsCustomRadioCheckboxes($form);

		$form.on('submit', function(e){
			$form.addClass('waiting').find('input:submit,button:submit').addClass('disabled');
		});

		$form.removeClass('waiting').find('input:submit,button:submit').removeClass('disabled');

		if ($form.find('.gform_save_link').length) {
			$form.find('.gform_save_link').before('<br/>');
		}

		if ($form.find('.validation_error').length && $form.closest('.row').length) {
			scrollTo($form);
		}

		if (window.gform) {
			window.gform.addAction('gform_post_conditional_logic_field_action', function (thisFormId, action, targetId, defaultValues, isInit) {
				setTimeout(function(){
					$window.trigger('resize');
				}, 100);
			});
		}

		$window.trigger('resize');

	});

	console.log('adding::gform_confirmation_loaded');

	$(document).bind('gform_confirmation_loaded', function(e, formId) {
		$window.trigger('resize');

		console.log('gform_confirmation_loaded', formId);

		// GATED CONTENT
		var $wrapper = $('#gform_confirmation_wrapper_' + formId);
		var $content = $('#gform_confirmation_message_' + formId);
		var $row = ($wrapper.length) ? $wrapper.closest('.row--gated-content') : [];
		if ($row.length) {

			console.log('is gated content form');

			$content.empty();

			var postID = $row.data('post-id');
			var rowID = $row.data('row-id');

			var isDownload = ($row.find('script[id^="gatedDownload_"]').length > 0);
			var downloadIDKey = (isDownload) ? 'gatedDownload_'+rowID+'_'+formId : '';
			var downloadURL = (isDownload && downloadIDKey !== '') ? window.global_vars.home + '/download/?dl=' + window[downloadIDKey] : '';

			var ajaxData = {
				action: 'gated_content',
				post_id: postID,
				row_id: rowID,
			};

			if ($row.find('script[id^="gatedDownload_"]').length) {
				var confirmationIDKey = 'gatedDownloadConfirmation_'+rowID+'_'+formId;
				if (window.hasOwnProperty(confirmationIDKey) && ( window[confirmationIDKey] === 'true') || window[confirmationIDKey] === true ) {
					ajaxData.content_type = 'download_confirmation';
				}
			}
			else if ($row.find('script[id^="gatedVideo_"]').length) {
				var videoIDKey = 'gatedVideoID_'+rowID+'_'+formId;
				if (window.hasOwnProperty(videoIDKey) && window[videoIDKey] !== '') {
					ajaxData.content_type = 'video';
				}
			}
			else if ($row.find('script[id^="gatedContent_"]').length) {
				var contentIDKey = 'gatedContentID_'+rowID+'_'+formId;
				if (window.hasOwnProperty(contentIDKey) && window[contentIDKey] !== '') {
					ajaxData.content_type = 'content';
				}
			}

			console.log('ajaxData', ajaxData);

			if (typeof ajaxData.content_type !== 'undefined') {
				$.ajax({
					url: window.global_vars.ajax_url,
					type: 'POST',
					data: ajaxData,
					beforeSend: function(jqXHR, settings){
						$wrapper.addClass('waiting');
					},
					complete: function(){
						$wrapper.removeClass('waiting');
					},
					success: function(result){
						console.log('gated_content_fetched', result);
						if (result && result !== '') {
							$content.html(result);
							setTimeout(function(){
								$content.fitVids();
							}, 10);
						}

						if (downloadURL !== '' && ajaxData.content_type === 'download_confirmation') {
							setTimeout(function(){
								window.location = downloadURL;
							}, 100);
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						$content.html('<div class="gated-content-error"><strong>' + window.global_vars.strings.error  + '</strong><br/><br/>'+textStatus+'</div>');
					}
				});
			}


			if (downloadURL !== '' && ajaxData.content_type !== 'download_confirmation') {
				window.location = downloadURL;
			}

		}

	});



	$(document).ready(function(){

		var $body = $('body');
		var $html = $('html');
		var $htmlBody = $('html, body');

		var windowWidth = $window.width();
		var windowHeight = $window.height();

		// Match values to _vars.scss
		var smallBreakpoint = 560;
		var mediumBreakpoint = 860;
		var largeBreakpoint = 1180;
		var extraLargeBreakpoint = 1440;

		var isLarge;
		var isExtraLarge;
		var isMedium;
		var isSmall;
		var isSmallAndMedium;

		var resizeTasks = [];
		var loadTasks = [];
		var scrollTasks = [];

		var scrollers = [];

		var $preloader = $('#preloader');

		$html.removeClass('no-js');

		if (isTouchDevice) {
			$html.addClass('is-touch');
		}

		function responsiveSizes() {
			windowWidth = $window.width();
			windowHeight = $window.height();
			isSmall = (windowWidth <= smallBreakpoint);
			isMedium = (windowWidth > smallBreakpoint && windowWidth <= mediumBreakpoint);
			isLarge = (windowWidth > mediumBreakpoint);
			isExtraLarge = (windowWidth > largeBreakpoint);
			isSmallAndMedium = (isSmall || isMedium);
		}
		responsiveSizes();

		if (supports.calc) {
			$html.addClass('calc');
		}

		/***************************
		 *
		 *	SAFE EXTERNAL LINKS
		 *  https://blog.dareboost.com/en/2017/03/target-blank-links-rel-noopener-performance-security/
		 *
		 ***************************/

		$('a[target="_blank"]').attr('rel', 'noopener');

		/***************************
		 *
		 *	FITVIDS
		 *
		 ***************************/
		$body.fitVids();


		/***************************
		 *
		 *	INLINE STYLES (CONTENT ROWS)
		 *
		 ***************************/

		var $rowStyles = $('.row-custom-css');
		if ($rowStyles.length) {
			$rowStyles.each(function(){
				$(this).detach().appendTo('head');
			});
		}

		/***************************
		 *
		 *	MODAL
		 *
		 ***************************/

		function openModal(selector) {
			var $target = $(selector);
			if ($target.length && $target.hasClass('modal')) {
				closeModal();// close any open ones first
				$html.addClass('modal-open');
				$target.addClass('modal--open').attr('aria-hidden', 'false');
			}
		}

		function closeModal() {
			$('.modal.modal--open').removeClass('modal--open').attr('aria-hidden', 'true');
			$html.removeClass('modal-open');
		}

		$body.on('click', '.modal__close', function(e){
			e.preventDefault();
			closeModal();
		});

		$body.on('click', 'a[href^="#"]', function(e){
			var $trigger = $(this);
			var targetSelector = $trigger.attr('href');
			var $target = $(targetSelector);
			if ($target.length && $target.hasClass('modal')) {
				e.preventDefault();
				openModal(targetSelector);
			}
		});


		/***************************
		 *
		 *	SCROLL TO
		 *
		 ***************************/

		$body.on('click', 'a.scrollto, li.scrollto > a, a[href^="#"]', function(e){
			var $link = $(this);
			var href = $link.attr('href');
			var sel = href.substring(href.indexOf('#'));
			var $target = $(sel);
			console.log('scrollto click', href, $target);
			if ($target.length && !$target.hasClass('modal') && !$link.hasClass('tabbed__nav__link')) {
				e.preventDefault();
				scrollTo($target);
			}
		});

		function hashScroll() {
			if (window.location.hash !== '' && window.location.hash !== '#') {
				var $hashScrollTarget = $(window.location.hash);
				if ($hashScrollTarget.length) {
					if ($hashScrollTarget.hasClass('modal-panel')) {
						openModal(window.location.hash);
					}
					else if ($hashScrollTarget.hasClass('tabbed__tab')) {
						$('a[href="' + window.location.hash + '"]').trigger('click');
					}
					else {
						scrollTo($hashScrollTarget);
					}
				}
			}
		}

		loadTasks.push(hashScroll);


		/***************************
		 *
		 *	SOCIAL
		 *
		 ***************************/

		$body.on('click', '.social-icons a', function(e){
			e.preventDefault();
			var $this = $(this);
			var rel = $this.data('rel');
			var url = $this.attr('href');
			Utils.centeredPopup(url, window.global_vars.strings.share_on + ' ' + rel + '', 450, 450);
		});

		/***************************
		 *
		 *	LAZY MEDIA
		 *
		 ***************************/

		function lazyLoadMedia($lazy) {

			if ($lazy.find('.lazy-media__image').length) {
				// large image already loaded
				return;
			}

			var $placeholder = $lazy.find('.lazy-media__placeholder');

			var $largeImg = $('<img src="" class="lazy-media__image">');
			$largeImg.on('load', function(){
				$largeImg.addClass('loaded');
				if ($lazy.hasClass('lazy-media--auto')) {
					objectFitImages($largeImg, {watchMQ: true});
				}
				else {
					objectFitImages($largeImg);
				}
				// Added for the header image
				if ($lazy.hasClass('hero-load-and-trigger')) {
					maybeStartHeroAnimation();
				}
				if ($placeholder.length) {
					$placeholder.removeClass('loaded');
				}
			});

			//var largeSrc = (!isSmall) ? $bg.data('wide') : $bg.data('large');
			var largeSrc = $placeholder.data('large');
			$largeImg.attr('src', largeSrc);
			$largeImg.attr('alt', $placeholder.attr('alt'));
			$lazy.append($largeImg);
		}

		function lazyLoadSwiperMedia(swiperObj) {
			var $lazy = $(swiperObj.$el).find('.swiper-slide:eq('+swiperObj.activeIndex+') .lazy-media');
			if ($lazy.length) {
				lazyLoadMedia($lazy);
			}
		}

		function initLazyMedia() {
			var $lazyMedia = $('.lazy-media');
			if ($lazyMedia.length) {
				$lazyMedia.each(function(){
					var $lazy = $(this);
					var $placeholder = $lazy.find('.lazy-media__placeholder');
					if ($placeholder.length) {

						if (!$lazy.hasClass('lazy-media--bg') && !$lazy.hasClass('alignleft') && !$lazy.hasClass('alignright')) {
							// Wordpress editor strips out data-width when inserted via tinymce, so for those inserts we use data-w
							var dataWidth = (typeof $placeholder.data('w') !== 'undefined') ? $placeholder.data('w') : $placeholder.data('width');
							var dataHeight = (typeof $placeholder.data('h') !== 'undefined') ? $placeholder.data('h') : $placeholder.data('height');
							var largeWidth = (typeof dataWidth === 'undefined' || dataWidth === '') ? 0 : parseInt(dataWidth, 10);
							var largeHeight = (typeof dataHeight === 'undefined' || dataHeight === '') ? 0 : parseInt(dataHeight, 10);
							var heightPercent = (largeWidth > 0 && largeHeight > 0) ? largeHeight / largeWidth : 0;
							if (heightPercent > 0) {
								$lazy.css('padding-top', (heightPercent * 100).toString() + '%');
							}
						}

						$placeholder.on('load', function(){
							$placeholder.addClass('loaded');
							if ($lazy.hasClass('lazy-media--auto')) {
								objectFitImages($placeholder, {watchMQ: true});
							}
							else {
								objectFitImages($placeholder);
							}
						});
						//var placeholderSrc = (!isSmall) ? $placeholder.data('src-wide') : $placeholder.data('src');
						var placeholderSrc = $placeholder.data('src');
						$placeholder.attr('src', placeholderSrc);
					}
				});
			}
		}

		initLazyMedia();

		if (lazyLoadInView) {
			$('.lazy-media').on('inview', function() {
				lazyLoadMedia( $(this) );
			});
		}
		else {
			loadTasks.push(function(){
				var $lazyMedia = $('.lazy-media');
				if ($lazyMedia.length) {
					$lazyMedia.each(function(){
						lazyLoadMedia( $(this) );
					});
				}
			});
		}

		var heroImagesLoaded = 0;
		function maybeStartHeroAnimation() {
			heroImagesLoaded++;
			var $animationScene = $('.animation-scene');

			var noOfImages = 7;
			if ($('.row--hero-major').hasClass('bg--dark')) {
				noOfImages = 4;
			} 
			if (noOfImages == heroImagesLoaded) {
				$animationScene.addClass('images-loaded');
			}
			
		}

		/***************************
		 *
		 *	TABLES
		 *
		 ***************************/

		var headertext = [];
		var $tableHeaders = $('table.table thead');
		var $tableBodies = $('table.table tbody');

		if ($tableHeaders.length && $tableBodies.length) {
			$tableHeaders.each(function(i){
				headertext[i]=[];
				var $tableHeader = $(this);
				$tableHeader.find('td,th').each(function(){
					var $cell = $(this);
					headertext[i].push($cell.text());
				});
			});

			$tableBodies.each(function(h){
				var $tableBody = $(this);
				$tableBody.find('tr').each(function(r){
					var $tableRow = $(this);
					$tableRow.find('td').each(function(j){
						$(this).attr('data-th', headertext[h][j])
					});
				});
			});
		}

		/***************************
		 *
		 *	CUSTOM SELECT
		 *
		 ***************************/

		var $customSelects = $('form:not(.gform_form) select:not(.hasCustomSelect):not(.stylized):not(.no-customSelect):not(.niceSelect)').not('[multiple]');
		if ($customSelects.length) {
			$customSelects.customSelect();
		}


		function responsiveCustomSelects() {
			var $allCustomSelects = $('select.hasCustomSelect');
			if ($allCustomSelects.length) {
				$allCustomSelects.trigger('render');
			}
		}
		resizeTasks.push(responsiveCustomSelects);

		/***************************
		 *
		 *	FULLY STYLIZED CUSTOM SELECT (SELECTRIC)
		 *
		 ***************************/

		$('select.stylized').selectric({
			disableOnMobile: true,
			arrowButtonMarkup: '',
			expandToItemText: true
		});

		/***************************
		 *
		 *	ICHECK
		 *
		 ***************************/

		$('input[type="checkbox"], input[type="radio"]').not('.no-input-replace').not('#ship-to-different-address-checkbox').each(function(){
			var $input = $(this);
			var $gfield = $input.closest('.gfield');
			// Gravity Forms iCheck is done in gf hooks
			if (!$gfield.length) {
				$input.iCheck({
					checkboxClass: 'icheckbox_minimal',
					radioClass: 'iradio_minimal',
					increaseArea: '20%' // optional
				});
				// ensures change events fire
				$input.on('ifClicked', function(e){
					$(this).trigger('change');
				});
			}
		});


		/***************************
		 *
		 *	SWIPER
		 *
		 ***************************/

		function swiperInit($swiperContainer, opts) {

			var sliderOpts = {
				centeredSlides: false,
				slidesPerView: 'auto',
				direction: 'horizontal',
				preloadImages: false,
				speed: 300,
				spaceBetween: 20,
				slidesOffsetBefore: 0,
				slidesOffsetAfter: 0,
				breakpoints: {
					559: {
						slidesOffsetBefore: 16,
						slidesOffsetAfter: 16
					}
				}
			};

			sliderOpts.on = {
				init: function(){
					lazyLoadSwiperMedia(this);
				},
				slideChange: function(){
					lazyLoadSwiperMedia(this);
				}
			};

			if (typeof $swiperContainer.data('speed') !== 'undefined' && $swiperContainer.data('speed') !== '') {
				sliderOpts.speed = parseInt($swiperContainer.data('speed'), 10);
			}

			if ($swiperContainer.data('swipe') === 'false' || $swiperContainer.data('swipe') === false) {
				sliderOpts.allowTouchMove = false;
			}

			if (typeof $swiperContainer.data('direction') !== 'undefined' && $swiperContainer.data('direction') === 'vertical') {
				sliderOpts.direction = 'vertical';
			}

			if ($swiperContainer.data('loop') !== 'true' && $swiperContainer.data('loop') !== true) {
				sliderOpts.loop = false;
			}

			if ($swiperContainer.data('parallax') !== 'false' && $swiperContainer.data('parallax') !== false) {
				sliderOpts.parallax = true;
			}

			if (typeof $swiperContainer.data('autoplay') !== 'undefined' && $swiperContainer.data('autoplay') !== '0' && $swiperContainer.data('autoplay') !== 0) {
				sliderOpts.autoplay = {
					delay: parseInt($swiperContainer.data('autoplay'), 10) * 1000
				};
			}

			if ($swiperContainer.find('.swiper-button-prev').length && $swiperContainer.find('.swiper-button-next').length) {
				sliderOpts.navigation = {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				};
			}

			if ($swiperContainer.find('.swiper-scrollbar').length) {
				sliderOpts.scrollbar = {
					el: '.swiper-scrollbar',
					hide: true
				};
			}

			if ($swiperContainer.find('.swiper-pagination').length) {
				sliderOpts.pagination = {
					el: '.swiper-pagination'
				};
				if ($swiperContainer.find('.swiper-pagination').data('progressbar')) {
					sliderOpts.pagination.type = 'progressbar';
				}
				else {
					//sliderOpts.pagination.dynamicBullets = true;
					sliderOpts.pagination.clickable = true;
				}
			}

			if ($swiperContainer.find('.swiper-lazy').length) {
				sliderOpts.lazy = true;
			}

			var $row = $swiperContainer.closest('.row');

			if ($row.length && $row.hasClass('row--posts-slider')) {
				sliderOpts.centeredSlides = false;
				sliderOpts.slidesPerView = 3;
				sliderOpts.spaceBetween = 0;
				sliderOpts.breakpoints = {
					680: {
						slidesPerView: 1,
						spaceBetween: 0
					},
					860: {
						slidesPerView: 2,
						spaceBetween: 0
					},
					1180: {
						slidesPerView: 3,
						spaceBetween: 0
					}
				};

				sliderOpts.on.slideChangeTransitionStart = function(){
					var $row = $(this.$wrapperEl).closest('.row');
					var $prevBtn = $row.find('.swiper-button-prev');
					if ( this.activeIndex === 0) {
						$prevBtn.addClass('swiper-button-disabled');
					}
					else {
						$prevBtn.removeClass('swiper-button-disabled');
					}

					var $nextBtn = $row.find('.swiper-button-next');
					if ( this.progress === 1) {
						$nextBtn.addClass('swiper-button-disabled');
					}
					else {
						$nextBtn.removeClass('swiper-button-disabled');
					}
				};

				$row.find('.swiper-button-next').click(function(e){
					e.preventDefault();
					var swiper = $(this).prevAll('.swiper-container:first').data('slider');
					if (typeof swiper !== 'undefined') {
						swiper.slideNext();
					}
				});
				$row.find('.swiper-button-prev').click(function(e){
					e.preventDefault();
					var swiper = $(this).prevAll('.swiper-container:first').data('slider');
					if (typeof swiper !== 'undefined') {
						swiper.slidePrev();
					}
				});

			}

			if ($row.length && $row.hasClass('row--explore-slider')) {
				sliderOpts.centeredSlides = false;
				sliderOpts.slidesPerView = 'auto';
				sliderOpts.spaceBetween = 40;
				sliderOpts.freeMode = true;
				sliderOpts.mousewheel = {
					forceToAxis: true
				};
				sliderOpts.scrollbar = {
					el: '.swiper-scrollbar',
					draggable: true,
					hide: false
				}
				sliderOpts.breakpoints = {
					680: {
						spaceBetween: 10
					},
					/* 860: {
						slidesPerView: 2,
						spaceBetween: 0
					},
					1180: {
						slidesPerView: 3,
						spaceBetween: 0
					} */
				};
			}

			if ($row.length && $row.hasClass('row--latest-news-slider')) {
				sliderOpts.centeredSlides = false;
				sliderOpts.slidesPerView = 'auto';
				sliderOpts.spaceBetween = 30;
				sliderOpts.freeMode = true;
				sliderOpts.mousewheel = {
					forceToAxis: true
				};
				sliderOpts.scrollbar = {
					el: '.swiper-scrollbar',
					draggable: true,
					hide: false
				};
				sliderOpts.breakpoints = {
					680: {
						spaceBetween: 15
					},
					/* 860: {
						slidesPerView: 2,
						spaceBetween: 0
					},
					1180: {
						slidesPerView: 3,
						spaceBetween: 0
					} */
				};
			}

			var allSliderOpts = $.extend({}, sliderOpts, opts);

			var slider = new Swiper($swiperContainer.get(0), allSliderOpts);
			$swiperContainer.data('slider', slider);
		}

		var $swipers = $('.swiper-container');
		if ($swipers.length) {
			$swipers.each(function(){
				swiperInit( $(this) );
			});
		}


		/***************************
		 *
		 *	ISCROLL
		 *
		 ***************************/

		var $scrollables = $('.scrollable');

		function initScrollable($scrollable) {
			if (typeof $scrollable !== 'undefined' && $scrollable.length) {
				var scroller = $scrollable.data('scroller');
				if (typeof scroller !== 'undefined') {
					setTimeout(function () {
						scroller.refresh();
						if (scroller.scrollerHeight > scroller.wrapperHeight) {
							$scrollable.addClass('scroll-enabled');
						}
						else {
							$scrollable.removeClass('scroll-enabled');
						}
					}, 10);
				}
				else {
					var iScrollOptions = {
						scrollX: false,
						scrollY: true,
						scrollbars: true,
						interactiveScrollbars: true,
						mouseWheel: true,
						probeType: 3
					};
					if (isTouchDevice) {
						iScrollOptions.interactiveScrollbars = false;
						iScrollOptions.mouseWheel = false;
						//iScrollOptions.click = false;
						iScrollOptions.click = true;
						//iScrollOptions.tap = true;
						iScrollOptions.preventDefaultException = {
							tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|A|LABEL)$/
						};
					}

					scroller = new IScroll($scrollable.get(0), iScrollOptions);

					if (scroller.scrollerHeight > scroller.wrapperHeight) {
						$scrollable.addClass('scroll-enabled');
					}
					else {
						$scrollable.removeClass('scroll-enabled');
					}

					scrollers.push(scroller);

					$scrollable.data('scroller', scroller);
				}
			}
		}

		if ($scrollables.length) {
			$scrollables.each(function(){
				initScrollable( $(this) );
			});
		}

		function responsiveScrollers() {
			if (scrollers.length) {
				$.each(scrollers, function(i, scroller){
					if (typeof scroller !== 'undefined') {
						try {
							scroller.refresh();
						}
						catch(e){}
					}
				});
			}
		}
		resizeTasks.push(responsiveScrollers);

		/***************************
		 *
		 *	ACCORDIAN
		 *
		 ***************************/

		if ($('.accordion').length) {
			var $accordion = $('.accordion');
			var singleOnly = false;
			if ($accordion.hasClass('accordion--single-opens')) {
				singleOnly = true;
			}

			$accordion.find('.accordion__trigger').on('click',function(e) {
				e.preventDefault();
				var $item = $(this).closest('.accordion__item');
				if ($item.hasClass('open')) {
					// close it
					$item.removeClass('open').addClass('closed');
					$item.find('.accordion__body').slideUp();
				} else {
					if (singleOnly) {
						$accordion.find('.accordion__item.open .accordion__body').slideUp();
						$accordion.find('.accordion__item.open').addClass('closed').removeClass('open');
					}
					$item.addClass('open').removeClass('closed');
					$item.find('.accordion__body').slideDown();
				}
				return false;
			});
		}

		/***************************
		 *
		 *	LIGHTCASE
		 *
		 ***************************/

		$('a[data-rel^=lightcase]').lightcase({
			swipe: true,
			fullscreenModeForMobile: true
		});



		/***************************
		 *
		 *	PARALLAX
		 *
		 ***************************/

		if (document.getElementById('animation-scene')) {
			
			setTimeout(function() {
				var scene = document.getElementById('animation-scene');
				var parallax = new Parallax(scene, {
					clipRelativeInput: true, 
					selector: '.layer'
				});

				var scene1 = document.getElementById('animation-scene-blade-left');
				var parallax1 = new Parallax(scene1, {
					clipRelativeInput: true, 
					selector: '.layer'
				});

				var scene2 = document.getElementById('animation-scene-blade-middle');
				var parallax2 = new Parallax(scene2, {
					clipRelativeInput: true, 
					selector: '.layer'
				});

				var scene3 = document.getElementById('animation-scene-blade-right');
				var parallax3 = new Parallax(scene3, {
					clipRelativeInput: true, 
					selector: '.layer'
				});
			},2000);
		}

		/***************************
		 *
		 *	EXPLORE HERO
		 *
		 ***************************/

		// mods to turn WP menu into what's needed on front-end
		var $globalExploreMenu = $('.modal--desktop-menu nav');
		var $localExploreMenu = $('.modal--explore nav');
		var $heroExploreMenu = $('.row--hero-with-solutions .solution-items nav');
		var $mobileExploreMenu = $('.modal--mobile-menu .level--global nav');

		if ($globalExploreMenu.length) {
			$globalExploreMenu.find('li').addClass('nav-item');
		}
		if ($localExploreMenu.length) {
			$localExploreMenu.find('li').addClass('nav-item');
		}
		if ($heroExploreMenu.length) {
			$heroExploreMenu.find('li').addClass('nav-item');
		}
		if ($mobileExploreMenu.length) {
			$mobileExploreMenu.find('li').addClass('nav-item');
		}


		$('.toggle-explore-hero').on('click',function(e) {
			e.preventDefault();
			if (isSmall || isMedium) {
				openModal('.modal--explore');
			} else {
				var $hero = $('.row--hero');
				var $sitebar = $('header.header');
				if ($hero.hasClass('explore-open')) {
					// close it
					$hero.removeClass('explore-open');
					if ( $sitebar.length ) {
						$sitebar.removeClass('out');
					}
				} else {
					$hero.addClass('explore-open');
					if ( $sitebar.length ) {
						$sitebar.addClass('out');
					}
				}
			}
		});

		/***************************
		 *
		 *	STICKY MENU
		 *
		 ***************************/

		function stickyNav() {
	 		var scrollTop = window.scrollY;
	 		if (scrollTop >= menubarTop) {
	 			$menubar.addClass('sticky');
	 		} else {
	 			$menubar.removeClass('sticky');
	 		}
	 	}

	 	var $menubar = $('nav.menubar');

		if ($menubar.length) {
			// mods to turn WP menu into what's needed on front-end
			$menubar.find('.navbar-nav li').addClass('nav-item');
			$menubar.find('.navbar-nav ul').addClass('sub-menu').removeClass('nav');

			var menubarTop = $('.row--hero').first().height();
		 	scrollTasks.push(stickyNav);
		}

		/***************************
		 *
		 *	STICKY SIDEBAR
		 *
		 ***************************/

		var stickySidebar = function() {
	 		var scrollTop = (window.scrollY + 80); // 80 is the sticky nav
	 		if (scrollTop >= sidebarTop) {
	 			$sidebar.removeClass('sticky-bottom').addClass('sticky');
	 		} else {
	 			$sidebar.removeClass('sticky sticky-bottom');
	 		}

	 		var scrollBottom = window.scrollY + window.innerHeight;
	 		var footerPos = $('footer.footer')[0].getBoundingClientRect();
	 		var footerTop = footerPos.top + window.scrollY;
	 		var sidebarInnerHeight = $sidebar.find('.sidebar__inner').height();
	 		if ((window.scrollY + 140) >= (footerTop - sidebarInnerHeight)) {
	 			$sidebar.removeClass('sticky').addClass('sticky-bottom');
	 		}

	 	}

		if ($('.sidebar').length) {
			var $sidebar = $('.sidebar');
			//var sidebarPos = $sidebar[0].getBoundingClientRect();
			//var sidebarTop = sidebarPos.top;
			var sidebarTop = $('.row--hero').first().height() + $('nav.menubar').first().height();
			//var footerHeight = $('footer.footer').height();
		 	scrollTasks.push(stickySidebar);
		}
		
		
		/***************************
		 *
		 *	HEADER/MODAL FUNCTIONALITY
		 *
		 ***************************/

		$('.trigger-explore-modal').on('click',function(e) {
			e.preventDefault();
			if (isSmallAndMedium) {
				openModal('.modal--mobile-menu');
			} else {
				openModal('.modal--desktop-menu');
			}
		});

		$('.trigger-search-modal').on('click',function(e) {
			e.preventDefault();
			openModal('.modal--search');
			$('.modal--search .site-search input').focus();
		});

		/***************************
		 *
		 *	MOBILE MENU
		 *
		 ***************************/

		// mods to turn WP menu into what's needed on front-end
		var $mobileMenu = $('.modal--mobile-menu .modal__content > ul:first').detach();

		var level1_HTML = '';
		var level2_HTML = '';
		var level3_HTML = '';

		level1_HTML += '<nav class="level--1 active" id="mm-top" data-level="1">';
		level1_HTML += '<ul class="level--1">';
		$mobileMenu.find('> li').each(function(i, li){
			var $item = $(li);
			level1_HTML += '<li class="' + $item.attr('class') + ' nav-item"';

			var $level2 = $item.find('> ul');
			if ($level2.length) {
				var level2Slug = 'submenu-' + i;
				level1_HTML += ' data-submenu="' + level2Slug + '"';

				level2_HTML += '<nav class="level--2" id="' + level2Slug + '" data-level="2">';
				level2_HTML += '<a href="#" class="nav__up-a-level"></a>';
				level2_HTML += '<h3>' + $item.find('> a').html() + '</h3>';
				level2_HTML += '<ul class="level--2" data-level="2">';
				$level2.find('> li').each(function(n, child){
					var $child = $(child);
					level2_HTML += '<li class="' + $child.attr('class') + ' nav-item"';

					var $level3 = $child.find('> ul');
					if ($level3.length) {
						var level3Slug = 'submenu-' + i + '-' + n;
						level2_HTML += ' data-submenu="' + level3Slug + '"';

						level3_HTML += '<nav class="level--3" id="' + level3Slug + '" data-level="3">';
						level3_HTML += '<a href="#" class="nav__up-a-level"></a>';
						level3_HTML += '<h3>' + $child.find('> a').html() + '</h3>';
						level3_HTML += '<ul class="level--3" data-level="3">';
						$level3.find('> li').each(function(n, grandchild){
							var $grandchild = $(grandchild);
							level3_HTML += '<li class="' + $grandchild.attr('class') + ' nav-item">';
							level3_HTML += $grandchild.find('> a').outerHTML();
							level3_HTML += '</li>';
						});
						level3_HTML += '</ul>';
						level3_HTML += '</nav>';
					}

					level2_HTML += '>';
					level2_HTML += $child.find('> a').outerHTML();
					level2_HTML += '</li>';
				});

				level2_HTML += '</ul>';
				level2_HTML += '</nav>';
			}

			level1_HTML += '>';
			level1_HTML += $item.find('> a').outerHTML();
			level1_HTML += '</li>';
		});

		level1_HTML += '</ul>';
		level1_HTML += '</nav>';

		// put it all together
		$('.modal--mobile-menu .modal__content').prepend(level1_HTML + level2_HTML + level3_HTML);



		 $('.modal--mobile-menu nav li[data-submenu] a').on('click',function(e) {
		 	e.preventDefault();
		 	// Going deeper one level
		 	var level = $(this).closest('nav').data('level') + 1;
		 	var newSubmenu = $(this).closest('li').data('submenu');
		 	$('.modal__content').removeClass('on-level--1 on-level--2 on--level--3').addClass('on-level--'+level);
		 	$('nav.level--'+level).removeClass('active');
		 	$('nav#'+newSubmenu).addClass('active');
		 });

		 $('.modal--mobile-menu a.nav__up-a-level').on('click',function(e) {
		 	e.preventDefault();
		 	var level = $(this).closest('nav').data('level')-1;
		 	$('.modal__content').removeClass('on-level--1 on-level--2 on-level--3').addClass('on-level--'+level);

		 	setTimeout(function() {
		 		$(this).closest('nav').removeClass('active');	
		 	},500);
		 });

		 $('.modal--mobile-menu a.open-global-menu').on('click',function(e) {
		 	$('nav.level--global').toggleClass('open');
		 });

		 // Global menu touch drag up
		 var $globalMenuAnchor = $('.modal--mobile-menu');
		 var gmaInitialY;
		 var gmaCurrentY;
		 var gmaOffsetY = 0;
		 var gmaDragActive = false;
		 $globalMenuAnchor.on('touchstart mousedown',function(e) {
		 	if (e.type === "touchstart") {
		 		gmaInitialY = e.touches[0].clientY - gmaOffsetY;
		 	} else {
		 		gmaInitialY = e.clientY - gmaOffsetY;
		 	}
		 	if (e.target === $('a.open-global-menu')[0]) {
		 		gmaDragActive = true;
		 	}
		 });
		 $globalMenuAnchor.on('touchend mouseup',function(e) {
		 	gmaInitialY = gmaCurrentY;
		 	gmaDragActive = false;
		 });
		 $globalMenuAnchor.on('touchmove mousemove',function(e) {
		 	if (gmaDragActive) {
		 		e.preventDefault();

		 		if (e.type === "touchmove") {
		 			gmaCurrentY = e.touches[0].clientY - gmaInitialY;
		 		} else {
		 			gmaCurrentY = e.clientY - gmaInitialY;
		 		}

		 		gmaOffsetY = gmaCurrentY;

		 		// set location
		 		if ($('nav.level--global').hasClass('open')) {
		 			console.log(gmaCurrentY);
		 			$('nav.level--global').css('transform','translateY('+gmaCurrentY+'px)');
		 		} else {
		 			console.log(gmaCurrentY);
		 			$('nav.level--global').css('transform','translateY(100vh - '+gmaCurrentY+'px)');
		 		}
		 	}
		 });


		/***************************
		 *
		 *	FOOTER
		 *
		 ***************************/

		// Take the WP menu and pull the first item out into a h3 before it as a header item
		$('.footer .footer__dropdown').each(function(){
			var $first = $(this).find('> ul > li:first');
			$first.detach();
			$(this).prepend('<h3>' + $first.html() + '</h3>');
		});

		$body.on('click', '.footer .footer__dropdown h3 a', function(e){
			if (isSmall) {
				e.preventDefault();
				var isOpen = $(this).closest('.footer__dropdown').hasClass('footer__dropdown--open');
				$('.footer__dropdown--open').removeClass('footer__dropdown--open').find('ul').slideUp(200);
				if (!isOpen) {
					$(this).closest('.footer__dropdown').addClass('footer__dropdown--open').find('ul').slideDown(200);
				}
			}
		});

		function responsiveFooterDropdowns() {
			var $openDropdowns = $('.footer__dropdown--open');
			if (!isSmall && $openDropdowns.length) {
				$openDropdowns.each(function(){
					$(this).removeClass('footer__dropdown--open').find('ul').show();
				});
			}
		}

		resizeTasks.push(responsiveFooterDropdowns);


		/***************************
		 *
		 *	PRIVACY COOKIE
		 *
		 ***************************/

		function setCookie(cname, cvalue, exdays) {
		  var d = new Date();
		  d.setTime(d.getTime() + (exdays*24*60*60*1000));
		  var expires = "expires="+ d.toUTCString();
		  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		}
		function getCookie(cname) {
		  var name = cname + "=";
		  var decodedCookie = decodeURIComponent(document.cookie);
		  var ca = decodedCookie.split(';');
		  for(var i = 0; i <ca.length; i++) {
		    var c = ca[i];
		    while (c.charAt(0) == ' ') {
		      c = c.substring(1);
		    }
		    if (c.indexOf(name) == 0) {
		      return c.substring(name.length, c.length);
		    }
		  }
		  return "";
		}

		// Should replace this with a server side version so that it'll show instantly
		if (getCookie('dcapriv') !== "true") {
			$('.alert--privacy').show();
		}

		$('.hide-privacy-alert').on('click',function(e) {
			e.preventDefault();
			setCookie('dcapriv','true',365);
			$('.alert--privacy').hide();
		});


		/***************************
		 *
		 *	CONTACT TABS
		 *
		 ***************************/

		$body.on('click', '.tabbed__nav a', function(e){
			e.preventDefault();
			var $link = $(this);
			var $row = $link.closest('.row');
			var tabSelector = $link.attr('href');
			var $tabTitle = $(tabSelector + '_title');
			if ($tabTitle.length) {
				$row.find('.tabbed__nav__link.active, .tabbed__tab__title.active').removeClass('active');
				$tabTitle.addClass('active');
				$link.addClass('active');
				var $officeField = $row.find('.gfield.office .ginput_container input');
				if ($officeField.length) {
					$officeField.attr('value', $link.text() ).val( $link.text() );
				}
			}
		});

		/***************************
		 *
		 *	RECORD SEARCH
		 *
		 ***************************/

		var $recordSearchRows = $('.row--record-search');

		if ($recordSearchRows.length) {

			$recordSearchRows.each(function(){

				var $row = $(this);
				var $chart = $row.find('.pie-graph');
				var chart = new Chart($chart.get(0).getContext('2d'), {
					type: 'doughnut',
					options: {
						responsive: true,
						maintainAspectRatio: false,
						legend: {
							display: false
						},
						tooltips: {
							enabled: false
						},
						hover: {
							mode: null
						},
						animation: {
							duration: 1,
							easing: 'easeOutCubic'
						},
						cutoutPercentage: 75
					},
					data: {
						labels: ['', ''],
						datasets: [{
							data: [0, 1],
							backgroundColor: [
								$chart.data('colour'),
								'#E4E4E4'
							],
							borderWidth: 0
						}]
					}
				});
				$chart.data('chart', chart);

			});

			$('.record-search__form').on('submit', function(e){
				e.preventDefault();
				var $form = $(this);

				var $row = $form.closest('.row');
				var rowID = $row.attr('id');

				var $chart = $row.find('.pie-graph');
				var $amount = $row.find('.chart-wrapper .amount');
				var $description = $row.find('.chart-wrapper > p');

				var option1 = $form.find('#'+rowID+'_dp1').val();
				var option2 = $form.find('#'+rowID+'_dp2').val();
				var recordsLookup = window[rowID + '_recordsLookup'];
				var lookupValue = (option1 && option2 && typeof recordsLookup !== 'undefined' && recordsLookup.length > option1 && recordsLookup[option1].length > option2) ? recordsLookup[option1][option2] : 'false';

				if (option1 && option2 && lookupValue !== 'false') {

					var val = parseInt(lookupValue, 10);
					var formattedVal = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					var chart = $chart.data('chart');

					if (typeof chart !== 'undefined') {
						// reset
						chart.data.datasets[0].data[0] = 0;
						chart.data.datasets[0].data[1] = 1;
						chart.update(0);

						var duration = 1;
						if (val <= 500) {
							duration = Math.ceil(val / 250);// 1 second per 250
						}
						else if (val <= 1000) {
							duration = Math.round(val / 450);// 1 second per 450
						}
						else if (val <= 2000) {
							duration = Math.round(val / 700);// 1 second per 700
						}
						else if (val <= 5000) {
							duration = Math.round(val / 1500);// 1 second per 1500
						}
						else {
							duration = Math.round(val / 3000);// 1 second per 3000
						}

						// animate
						chart.options.animation.duration = duration * 1000;
						chart.update();

						chart.data.datasets[0].data[0] = 1;
						chart.data.datasets[0].data[1] = 0;
						chart.update();

						var countUp = new CountUp($amount.get(0), 0, val, 0, duration, { easingFn: easeOutCubicFunc }).start();

						$description.css('opacity', 1);
					}

					$amount.html( formattedVal );

				}

			});

			$('.record-search__field select').on('change', function(){
				var $select = $(this);
				$select.closest('form').submit();
			});

		}



		/***************************
		 *
		 *	SCROLL
		 *
		 ***************************/

		function onWindowScroll() {
			var scrolled = $window.scrollTop();
			var scrolledOver = (isSmall) ? (scrolled > 50) : (scrolled > 100);
			$html.toggleClass('scrolled', scrolledOver);
			$.each(scrollTasks, function(i, func){
				func();
			});
		}

		window.onWindowScroll = onWindowScroll;
		$window.on('scroll', onWindowScroll);


		/***************************
		 *
		 *	RESPONSIVE / BREAKPOINTS
		 *
		 ***************************/

		function onWindowResize() {

			responsiveSizes();

			$.each(resizeTasks, function(i, func){
				func();
			});

			var $selects = $('.gform_wrapper form').find('.gfield_select, .gfield_date_dropdown_day select, .gfield_date_dropdown_month select, .gfield_date_dropdown_year select, .ginput_container_time select').not('[multiple]').not('.chzn-done');
			if ($selects.length) {
				$selects.each(function(){
					var $select = $(this);
					var $selectParent = $select.closest('.ginput_container');
					$select.width($selectParent.width()).trigger('render');
				});
			}

		}

		window.onWindowResize = onWindowResize;
		$window.on('resize', Utils.debounce(onWindowResize, 50));

		$window.trigger('resize');
		$window.trigger('scroll');

		var preloaderWaiting = true;
		var windowLoaded = false;

		setTimeout(function(){
			preloaderWaiting = false;
			if (windowLoaded) {
				onWindowLoaded();
			}
		}, 2000);

		function processLoadTasks() {
			$.each(loadTasks, function(i, func){
				func();
			});
		}

		function onWindowLoaded() {
			$body.removeClass('loading');
			setTimeout(function(){
				if ($preloader.length) {
					$preloader.fadeOut(300, function(){
						$preloader.remove();
						processLoadTasks();
						$window.trigger('resize');
					});
				}
				else {
					processLoadTasks();
					$window.trigger('resize');
				}
			}, 700);
		}

		$window.on('load', function(){
			onWindowResize();
			windowLoaded = true;
			if (!preloaderWaiting) {
				onWindowLoaded();
			}
		});

	});

})(jQuery);
